<template>
  <div class="input">
    <label v-if="label" :for="id" class="input__label">{{ label }}</label>

    <input
      :id="id"
      :type="type"
      :value="value"
      class="input__field"
      @input="e => $emit('input', e.target.value)"
      @focus="$emit('focus')"
    />

    <p v-if="error" class="input__error">{{ error }}</p>
  </div>
</template>

<script>
import randomId from 'random-entities/id'

export default {
  name: 'InputText',
  props: {
    value: { type: [String, Number], required: true },
    id: { type: String, default: randomId },
    label: { type: String, default: null },
    type: { type: String, default: 'text' },
    error: { type: String, default: null }
  }
}
</script>
